import styled from "styled-components";

export const TagListContainer = styled.ul<{ fg?: string; bg?: string }>`
  display: flex;
  flex-wrap: wrap;
  /* margin-top: 8px; */

  li {
    background: ${({ bg }) => bg || "#e5eaff"};
    padding: 4px 8px;
    margin-right: 8px;
    font-size: 0.75em;
    color: ${({ fg }) => fg || "var(--blue)"};
    border-radius: 6px;
    margin-bottom: 8px;
  }
`;
